type MaterialCaseType = "MAV" | "MST";

function normalizeMaterialCaseTypes(caseTypes: readonly MaterialCaseType[]) {
  return [...new Set(caseTypes)].sort();
}

function normalizeGroupIds(groupIds: readonly number[]) {
  return [...new Set(groupIds)].sort((a, b) => a - b);
}

export const queryKeys = {
  cases: ["cases"] as const,
  case: (id: string | number) => ["cases", id] as const,
  taskAttachments: (taskId: string | number) =>
    ["tasks", taskId, "attachments"] as const,
  attachmentSasUrl: (
    parentKind: "case" | "task",
    parentId: string | number,
    attachmentId: string | number,
  ) => ["attachments", parentKind, parentId, attachmentId, "sas"] as const,
  metrics: ["cases", "metrics"] as const,
  comments: (caseId: string | number) => ["cases", caseId, "comments"] as const,
  caseTasks: (caseId: string | number) => ["cases", caseId, "tasks"] as const,
  me: ["me"] as const,
  groups: ["groups"] as const,
  lookups: {
    literas: ["lookups", "literas"] as const,
    fbs: ["lookups", "fbs"] as const,
  },
  materialCases: {
    listRoot: ["materialCases", "list"] as const,
    list: (
      caseTypes: readonly MaterialCaseType[],
      options?: {
        statusId?: number;
        search?: string;
        assignedGroupId?: number;
        page?: number;
        pageSize?: number;
      },
    ) =>
      [
        "materialCases",
        "list",
        normalizeMaterialCaseTypes(caseTypes).join("|"),
        options,
      ] as const,
    detail: (caseType: MaterialCaseType, id: string | number) =>
      ["materialCases", "detail", caseType, id] as const,
    assignableUsers: (id: string | number) =>
      ["materialCases", "assignableUsers", id] as const,
    assignableTargets: (id: string | number) =>
      ["materialCases", "assignableTargets", id] as const,
    myTasks: ["materialCases", "myTasks"] as const,
    myTasksScoped: (
      currentUserId: string | null,
      functionalGroupIds: readonly number[],
    ) =>
      [
        "materialCases",
        "myTasks",
        currentUserId ?? "anonymous",
        normalizeGroupIds(functionalGroupIds).join("|"),
      ] as const,
  },
} as const;
